import { useState, useEffect } from 'react';
import { throttleToAnimationFrame } from '@utils/common';

function useTruncatedState(contentRef, contentKey) {
  const [isTruncated, setTruncated] = useState(false);
  useEffect(() => {
    const onUpdate = () => {
      const content = contentRef.current;
      if (!content) {
        return;
      }
      setTruncated(content.scrollWidth > content.clientWidth);
    };

    // In case we can defer updating the truncation state then we should do so
    // as recalculating styles on many items (e.g. on mount of a large list) may
    // be performance intensive.
    if ("requestIdleCallback" in window) {
      requestIdleCallback(onUpdate);
    } else {
      onUpdate();
    }
    const throttled = throttleToAnimationFrame(onUpdate);
    window.addEventListener("resize", throttled);
    window.addEventListener("orientationchange", throttled);
    return () => {
      window.removeEventListener("resize", throttled);
      window.removeEventListener("orientationchange", throttled);
    };
  }, [contentRef, contentKey]);
  return isTruncated;
}

export { useTruncatedState };
//# sourceMappingURL=truncated-state.js.map
